module.exports = __webpack_public_path__ + "static/media/11.cb6f9c18.JPG";